import { fetcher } from 'utils/axios';

/**
 * הודעות מתוזמנות — שרת הנוד מתזמן (sendMessage עם scheduledSendTime) והצרכן
 * api-broadcast-queue שולח בזמן שנקבע דרך הליבה ב-C#. הצ'אט מתזמן כאן כי
 * המסלול הישיר ל-C# שולח מיידית ומתעלם מתזמון.
 */

export type ScheduledMessage = {
  id: string;
  phone: string;
  scheduledSendTime: string;
  kind: 'session_text' | 'session_file' | 'meta_template' | 'catalog_template';
  text: string | null;
  templateName: string | null;
  fileLink: string | null;
  fileName: string | null;
  createdBy: string | null;
};

function extractEnvelopeData<T>(response: any): T {
  if (response && typeof response === 'object' && 'data' in response && response.success !== undefined) {
    return response.data as T;
  }
  return response as T;
}

export type ScheduleMessageParams = {
  phone: string;
  scheduledSendTime: string;
  text?: string;
  fileLink?: string;
  fileName?: string;
  templateName?: string;
  /** אובייקט לפי שם: header_1 / body_N / button_N */
  templateParameters?: Record<string, string> | string[];
  headerFileLink?: string;
  headerFileName?: string;
};

export async function scheduleMessage(params: ScheduleMessageParams): Promise<void> {
  await fetcher(
    'post',
    [
      '/api/services/sendMessage',
      {
        data: {
          phone: params.phone,
          scheduledSendTime: params.scheduledSendTime,
          source: 'front',
          ...(params.text ? { text: params.text } : {}),
          ...(params.fileLink ? { fileLink: params.fileLink } : {}),
          ...(params.fileName ? { fileName: params.fileName } : {}),
          ...(params.templateName ? { templateName: params.templateName } : {}),
          ...(params.templateParameters ? { templateParameters: params.templateParameters } : {}),
          ...(params.headerFileLink ? { headerFileLink: params.headerFileLink } : {}),
          ...(params.headerFileName ? { headerFileName: params.headerFileName } : {}),
        },
      },
    ],
    'servernode',
  );
}

export async function fetchScheduledMessages(phone: string): Promise<ScheduledMessage[]> {
  const response = await fetcher(
    'post',
    ['/api/services/listScheduledMessages', { data: { phone } }],
    'servernode',
  );
  const data = extractEnvelopeData<{ scheduledMessages?: ScheduledMessage[] }>(response);
  return Array.isArray(data?.scheduledMessages) ? data.scheduledMessages : [];
}

export async function cancelScheduledMessage(scheduledMessageId: string): Promise<void> {
  await fetcher(
    'post',
    ['/api/services/cancelScheduledMessage', { data: { scheduledMessageId } }],
    'servernode',
  );
}

/** רענון רצועת ההודעות הממתינות בצ'אט — משודר אחרי תזמון/ביטול */
export const SCHEDULED_MESSAGES_CHANGED_EVENT = 'funner:scheduled-messages-changed';
export function notifyScheduledMessagesChanged() {
  try {
    window.dispatchEvent(new CustomEvent(SCHEDULED_MESSAGES_CHANGED_EVENT));
  } catch {
    /* ignore */
  }
}
